import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "./WhiteButton.scss";

function WhiteButton(props) {
  const {
    onClick,
    href,
    disabled,
    className,
    style,
    text,
    svg,
    svgAfterText,
    hoverColor,
  } = props;

  const navigate = useNavigate(); // <-- use the hook here

  const hoverStyle = hoverColor ? { "--hover-color": hoverColor } : {};

  const handleClick = () => {
    if (href) navigate(href); // <-- navigate with navigate
  };

  return (
    <div
      className={
        "white-btn " +
        (disabled ? "white-btn-disabled " : "") +
        (className ? className : "")
      }
      style={{ ...style, ...hoverStyle }}
      onClick={onClick || handleClick}>
      {svgAfterText ? (
        <>
          {text}
          {svg && svg}
        </>
      ) : (
        <>
          {svg && svg}
          {text}
        </>
      )}
    </div>
  );
}

export default WhiteButton